// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Enhanced Landing Page Styles */
.landing-container {
  height: 100vh;
  height: 100dvh;
  min-height: 100dvh;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 25%, var(--brand-primary-light) 50%, var(--brand-primary) 75%, var(--brand-primary-dark) 100%);
  background-size: 400% 400%;
  animation: gradientShift 15s ease infinite;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  position: relative;
  overflow: hidden;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

.landing-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 80%, rgba(var(--brand-primary-rgb), 0.3) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(var(--brand-primary-rgb), 0.25) 0%, transparent 50%),
    radial-gradient(circle at 40% 40%, rgba(var(--brand-primary-rgb), 0.3) 0%, transparent 50%);
  animation: floatingOrbs 20s ease-in-out infinite;
}

@keyframes floatingOrbs {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  33% { transform: translateY(-20px) rotate(120deg); }
  66% { transform: translateY(10px) rotate(240deg); }
}

.landing-header {
  flex-shrink: 0;
  padding: 14px 40px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0 0 20px 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 10;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
}

.header-logo {
  width: 168px;
  height: auto;
}

.landing-main {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: clamp(32px, 5vw, 72px);
  padding: 24px 48px;
  text-align: center;
  position: relative;
  z-index: 5;
  width: 100%;
  max-width: 1180px;
  margin: 0 auto;
}

.landing-main::before {
  content: '';
  position: absolute;
  top: 10%;
  left: 10%;
  width: 200px;
  height: 200px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.landing-main::after {
  content: '';
  position: absolute;
  bottom: 20%;
  right: 15%;
  width: 150px;
  height: 150px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 8s ease-in-out infinite reverse;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

.welcome-section {
  margin-bottom: 0;
  max-width: 540px;
  flex: 1 1;
  text-align: left;
  position: relative;
  z-index: 10;
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.welcome-title {
  font-size: clamp(2rem, 3.6vw, 3.1rem);
  font-weight: 800;
  color: white;
  margin-bottom: 10px;
  line-height: 1.12;
  white-space: normal;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 50%, #e0f2fe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: titleGlow 3s ease-in-out infinite alternate;
}

.welcome-tagline {
  font-size: clamp(1.05rem, 1.8vw, 1.45rem);
  font-weight: 600;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.96);
  margin: 0 0 14px;
  line-height: 1.35;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);
  animation: fadeInUp 1s ease-out 0.15s both;
}

@keyframes titleGlow {
  from {
    text-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);
  }
  to {
    text-shadow: 0 8px 30px rgba(255, 255, 255, 0.6);
  }
}

.welcome-subtitle {
  font-size: clamp(0.95rem, 1.25vw, 1.15rem);
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.55;
  font-weight: 400;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 1s ease-out 0.3s both;
}

.login-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(25px);
  border-radius: 24px;
  padding: 32px 28px;
  box-shadow: 
    0 25px 50px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(255, 255, 255, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.2);
  width: 100%;
  max-width: 420px;
  flex-shrink: 0;
  animation: slideInUp 1s ease-out;
  position: relative;
  z-index: 10;
  transition: all 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
  box-shadow: 
    0 35px 70px rgba(0, 0, 0, 0.2),
    0 0 0 1px rgba(255, 255, 255, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
}

@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.language-selector {
  text-align: right;
}

.lang-select {
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  color: #4A5568;
  cursor: pointer;
  transition: all 0.3s ease;
}

.lang-select:focus {
  outline: none;
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb), 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
}

.login-header h2 {
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin-bottom: 8px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.login-header p {
  color: rgba(255, 255, 255, 0.85);
  font-size: 0.95rem;
  margin: 0;
  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);
}

.login-buttons {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
}

.primary-btn {
  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);
  color: white;
  box-shadow: 
    0 8px 25px rgba(var(--brand-primary-rgb), 0.4),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
}

.primary-btn:focus-visible {
  outline: 2px solid rgba(var(--brand-primary-rgb), 0.35);
  outline-offset: 2px;
}

.primary-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.primary-btn:hover::before {
  left: 100%;
}

.primary-btn:hover {
  transform: translateY(-3px);
  box-shadow: 
    0 12px 35px rgba(var(--brand-primary-rgb), 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.social-login {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.social-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 
    0 4px 15px rgba(0, 0, 0, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.social-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.5);
  transform: translateY(-2px);
  box-shadow: 
    0 8px 25px rgba(0, 0, 0, 0.15),
    inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.social-btn img {
  width: 20px;
  height: 20px;
}

.btn-icon {
  font-size: 18px;
}

.landing-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.25);
}

.landing-footer p {
  color: #A0AEC0;
  font-size: 14px;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .landing-container {
    height: 100dvh;
    min-height: 100dvh;
    max-height: 100dvh;
    overflow: hidden;
    padding-top: env(safe-area-inset-top, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  .landing-header {
    flex-shrink: 0;
    padding: 10px 16px;
    border-radius: 0 0 12px 12px;
  }
  
  .header-content {
    flex-direction: row;
    gap: 12px;
  }

  .header-logo {
    width: 140px;
  }
  
  .landing-main {
    flex: 1 1;
    flex-direction: column;
    min-height: 0;
    padding: 12px 16px 16px;
    justify-content: space-evenly;
    gap: 12px;
    overflow: hidden;
    max-width: none;
  }
  
  .landing-main::before,
  .landing-main::after {
    display: none;
  }

  .welcome-section {
    margin-bottom: 0;
    flex: 0 1 auto;
    flex-shrink: 1;
    min-height: 0;
    max-width: 100%;
    text-align: center;
  }
  
  .welcome-title {
    font-size: clamp(1.25rem, 5vw, 1.7rem);
    margin-bottom: 6px;
    line-height: 1.2;
  }

  .welcome-tagline {
    font-size: clamp(0.88rem, 3.4vw, 1.05rem);
    margin-bottom: 8px;
  }
  
  .welcome-subtitle {
    font-size: clamp(0.8rem, 3.2vw, 0.92rem);
    line-height: 1.4;
  }
  
  .login-card {
    padding: 18px 16px;
    max-width: 100%;
    border-radius: 16px;
    flex-shrink: 0;
  }

  .login-card:hover {
    transform: none;
  }
  
  .login-header {
    margin-bottom: 14px;
  }

  .login-header h2 {
    font-size: 1.15rem;
    margin-bottom: 4px;
    color: white;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  }
  
  .login-header p {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.8);
    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);
  }

  .login-buttons {
    gap: 10px;
  }

  .login-btn {
    padding: 12px 16px;
    font-size: 14px;
  }
  
  .landing-footer {
    margin-top: 12px;
    padding-top: 10px;
  }

  .landing-footer p {
    font-size: 11px;
  }

  .lang-select {
    padding: 6px 8px;
    font-size: 12px;
  }
}

@media (max-width: 480px) {
  .landing-header {
    padding: 8px 12px;
  }
  
  .header-logo {
    width: 128px;
  }
  
  .welcome-title {
    font-size: clamp(1.1rem, 4.8vw, 1.4rem);
  }

  .welcome-tagline {
    font-size: clamp(0.82rem, 3.4vw, 0.95rem);
    margin-bottom: 6px;
  }

  .welcome-subtitle {
    font-size: clamp(0.75rem, 3.1vw, 0.85rem);
  }
  
  .login-card {
    padding: 14px 14px;
  }
  
  .login-header h2 {
    font-size: 1.05rem;
  }
}

@media (max-width: 768px) and (max-height: 700px) {
  .landing-main {
    padding: 8px 14px 12px;
  }

  .welcome-title {
    font-size: clamp(1.05rem, 4.4vw, 1.3rem);
    line-height: 1.2;
  }

  .welcome-tagline {
    font-size: 0.85rem;
    margin-bottom: 4px;
  }

  .welcome-subtitle {
    font-size: 0.78rem;
    line-height: 1.3;
  }

  .login-card {
    padding: 12px 14px;
  }

  .login-header {
    margin-bottom: 10px;
  }

  .landing-footer {
    margin-top: 8px;
    padding-top: 8px;
  }
}

/* Login page — viewport-fit PC split (login vs signup) */
.login-page-logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.login-page-logo:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.7);
  outline-offset: 4px;
  border-radius: 8px;
}

/* Login page: fit viewport at any browser zoom — never clip the submit button */
.login-page.landing-container {
  height: 100dvh;
  min-height: 100dvh;
  max-height: none;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.login-page .landing-header {
  padding: clamp(8px, 1.4vh, 14px) clamp(16px, 3vw, 40px);
}

.login-page .header-logo {
  width: clamp(120px, 18vw, 168px);
}

.login-page-shell {
  flex: 1 0 auto;
  min-height: 0;
  display: grid;
  grid-template-columns: minmax(0, 1.15fr) minmax(240px, 0.85fr);
  gap: clamp(12px, 2.5vh, 36px);
  align-items: start;
  width: 100%;
  max-width: min(980px, 100%);
  margin: 0 auto;
  padding: clamp(10px, 2vh, 20px) clamp(16px, 3vw, 40px) clamp(16px, 3vh, 28px);
  position: relative;
  z-index: 5;
  box-sizing: border-box;
}

.login-auth-card,
.signup-panel {
  position: relative;
  z-index: 10;
  min-height: 0;
  min-width: 0;
  max-width: 100%;
  animation: fadeInUp 0.7s cubic-bezier(0.25, 1, 0.5, 1) both;
  box-sizing: border-box;
}

.signup-panel {
  animation-delay: 0.12s;
}

.login-auth-card {
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(22px);
  -webkit-backdrop-filter: blur(22px);
  border-radius: 24px;
  padding: clamp(16px, 2.4vh, 28px) clamp(16px, 2.5vw, 32px);
  box-shadow:
    0 22px 48px rgba(0, 0, 0, 0.16),
    0 0 0 1px rgba(255, 255, 255, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.55);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.login-page .login-top {
  width: 100%;
  margin: 0 0 clamp(10px, 1.6vh, 18px);
  align-items: flex-start;
  text-align: left;
}

.login-page .login-top > h1 {
  font-size: clamp(1.15rem, 1.8vw + 0.4vh, 1.7rem);
  line-height: 1.25;
  margin-bottom: 6px;
  color: #1A365D;
}

.login-page .login-subtitle {
  font-size: clamp(0.82rem, 1.1vw, 0.95rem);
  color: #4A5568;
  line-height: 1.4;
}

.login-page .login-form-div {
  margin: 0;
  width: 100%;
}

.login-page .login-form {
  padding: 0;
}

.login-page .login-form > .label {
  margin-bottom: 4px;
  font-size: 13px;
  line-height: 18px;
}

.login-page .input {
  padding: clamp(10px, 1.4vh, 12px) 14px;
  margin-bottom: clamp(8px, 1.4vh, 14px);
}

.login-page .forgot-password {
  margin-bottom: clamp(10px, 1.6vh, 16px);
}

.login-page .error-message,
.login-page .session-expired-message {
  margin-bottom: 12px;
  padding: 10px 12px;
}

.login-page .login-button {
  margin-bottom: 0;
  margin-top: 4px;
  padding: clamp(12px, 1.6vh, 14px) 20px;
  font-size: 15px;
  letter-spacing: 0.01em;
  width: 100%;
  flex-shrink: 0;
}

.login-page .login-button:hover:not(:disabled) {
  transform: translateY(-2px) scale(1.01);
}

.login-page .login-button:active:not(:disabled) {
  transform: scale(0.98);
}

/* Short desktop viewports / zoomed browsers: keep login CTA reachable */
@media (min-width: 960px) and (max-height: 820px) {
  .login-page .landing-header {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .login-page-shell {
    padding-top: 10px;
    padding-bottom: 16px;
    gap: 14px;
  }

  .login-auth-card,
  .signup-panel {
    padding: 16px 20px;
  }

  .login-page .login-top {
    margin-bottom: 10px;
  }

  .login-mode-chip {
    margin-bottom: 6px;
  }

  .login-page .input {
    margin-bottom: 8px;
    padding: 10px 12px;
  }

  .signup-panel__title {
    font-size: 1.25rem;
  }

  .signup-panel__text {
    font-size: 0.88rem;
  }
}

@media (min-width: 960px) and (max-height: 700px) {
  .login-page-shell {
    grid-template-columns: minmax(0, 1fr) minmax(220px, 0.75fr);
  }

  .login-page .login-top > h1 {
    font-size: 1.2rem;
  }

  .login-page .login-subtitle {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}

.password-toggle {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 4px;
  margin-left: 8px;
  cursor: pointer;
  border-radius: 8px;
  color: #718096;
}

.password-toggle img {
  height: 18px;
  width: 18px;
  opacity: 0.7;
}

.password-toggle:hover img {
  opacity: 1;
}

.password-toggle:focus-visible {
  outline: 2px solid rgba(var(--brand-primary-rgb), 0.35);
  outline-offset: 2px;
}

.signup-panel {
  background: linear-gradient(165deg, var(--brand-primary) 0%, var(--brand-primary-dark) 78%);
  border-radius: 24px;
  padding: 32px 28px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  box-shadow:
    0 22px 48px rgba(0, 0, 0, 0.2),
    inset 0 1px 0 rgba(255, 255, 255, 0.22);
  border: 1px solid rgba(255, 255, 255, 0.22);
  overflow: hidden;
}

.signup-panel::before {
  content: '';
  position: absolute;
  top: -40px;
  right: -30px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, transparent 70%);
  pointer-events: none;
}

.signup-panel::after {
  content: '';
  position: absolute;
  bottom: -50px;
  left: -20px;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  pointer-events: none;
}

.signup-panel__kicker {
  display: inline-flex;
  margin: 0;
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.28);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.signup-panel__title {
  margin: 4px 0 0;
  font-size: clamp(1.45rem, 2.2vw, 1.9rem);
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.02em;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.18);
}

.signup-panel__text {
  margin: 0 0 8px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.9);
  max-width: 28ch;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.signup-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 8px;
  padding: 14px 20px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 700;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  text-decoration: none;
  color: var(--brand-primary-dark);
  background: #fff;
  box-shadow:
    0 10px 28px rgba(0, 0, 0, 0.18),
    0 0 0 1px rgba(255, 255, 255, 0.5);
  transition: transform 0.35s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.35s cubic-bezier(0.25, 1, 0.5, 1);
  animation: signupGlow 2.8s ease-in-out infinite alternate;
  position: relative;
  z-index: 1;
}

.signup-button:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow:
    0 16px 36px rgba(0, 0, 0, 0.22),
    0 0 0 1px rgba(255, 255, 255, 0.7);
}

.signup-button:active {
  transform: scale(0.98);
}

.signup-button:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 3px;
}

@keyframes signupGlow {
  from {
    box-shadow:
      0 10px 28px rgba(0, 0, 0, 0.18),
      0 0 0 1px rgba(255, 255, 255, 0.45);
  }
  to {
    box-shadow:
      0 12px 34px rgba(255, 255, 255, 0.28),
      0 0 0 1px rgba(255, 255, 255, 0.7);
  }
}

@media (prefers-reduced-motion: reduce) {
  .signup-button {
    animation: none;
  }

  .login-auth-card,
  .signup-panel {
    animation: none;
  }
}

@media (max-width: 959px) {
  .login-page-shell {
    grid-template-columns: 1fr;
    max-width: 520px;
    padding: 16px 24px 24px;
    gap: 16px;
    overflow: auto;
  }

  .login-auth-card,
  .signup-panel {
    padding: 22px 22px;
  }

  .signup-panel {
    align-items: stretch;
    text-align: left;
  }

  .signup-panel__text {
    max-width: none;
  }
}

@media (max-width: 768px), (max-height: 520px) and (pointer: coarse) {
  html:has(.login-page),
  body:has(.login-page) {
    height: 100%;
    overflow: hidden;
    overscroll-behavior: none;
  }

  .login-page.landing-container {
    /* Follow the visual viewport. The page fills that box; the keyboard
       feature bar is kept clear by padding and scroll, not by a hole in the page. */
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: var(--login-vvh, 100dvh);
    min-height: 0;
    max-height: var(--login-vvh, 100dvh);
    transform: translateY(var(--login-vv-top, 0px));
    overflow: hidden;
    -webkit-overflow-scrolling: auto;
    padding-top: env(safe-area-inset-top, 0px);
    padding-bottom: 0;
    box-sizing: border-box;
  }

  .login-page .landing-header {
    padding: 8px 14px;
  }

  .login-page .header-logo {
    width: auto;
    height: 40px;
    max-width: 148px;
    object-fit: contain;
  }

  .login-page-shell {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    max-width: none;
    padding: 8px 16px max(12px, var(--login-safe-bottom, env(safe-area-inset-bottom, 0px)));
    gap: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    align-content: stretch;
    justify-content: flex-start;
    scroll-padding-top: 8px;
    scroll-padding-bottom: 16px;
  }

  .login-auth-card {
    flex: 0 0 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 14px 16px 16px;
    border-radius: 18px;
    overflow: visible;
  }

  .login-page .login-form-div {
    flex: 0 0 auto;
  }

  .login-page .login-form .input,
  .login-page .login-form .label,
  .login-page .login-button {
    scroll-margin-top: 12px;
    scroll-margin-bottom: 16px;
  }

  .login-page .legal-footer {
    margin-top: 10px;
    font-size: 11px;
    line-height: 1.35;
    gap: 0.2rem 0.45rem;
  }

  .login-page .input {
    margin-bottom: 10px;
  }

  .login-page .forgot-password {
    margin-bottom: 10px;
  }

  .login-page .login-top {
    margin-bottom: 12px;
    align-items: center;
    text-align: center;
    flex-shrink: 0;
  }

  .login-page .login-top > h1 {
    font-size: 1.28rem;
  }

  .login-page .login-subtitle {
    font-size: 0.82rem;
  }

  .login-mode-chip {
    align-self: center;
  }

  .signup-panel {
    flex: 0 0 auto;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 8px 12px;
    padding: 12px 14px;
    border-radius: 16px;
  }

  .signup-panel::before,
  .signup-panel::after {
    display: none;
  }

  .signup-panel__kicker {
    display: none;
  }

  .signup-panel__title {
    flex: 1 1 auto;
    font-size: 1.05rem;
    margin: 0;
  }

  .signup-panel__text {
    display: none;
  }

  .signup-button {
    width: auto;
    min-width: 7.5rem;
    margin-top: 0;
    padding: 10px 16px;
    font-size: 14px;
    animation: none;
  }

  /* Keyboard open: collapse chrome so email/password stay in view */
  html.login-keyboard-open .login-page .landing-header,
  body.login-keyboard-open .login-page .landing-header {
    padding: 4px 12px;
  }

  html.login-keyboard-open .login-page .header-logo,
  body.login-keyboard-open .login-page .header-logo {
    width: auto;
    height: 28px;
    max-width: 108px;
  }

  html.login-keyboard-open .login-page .login-subtitle,
  html.login-keyboard-open .login-page .login-mode-chip,
  html.login-keyboard-open .login-page .signup-panel,
  html.login-keyboard-open .login-page .legal-footer,
  body.login-keyboard-open .login-page .login-subtitle,
  body.login-keyboard-open .login-page .login-mode-chip,
  body.login-keyboard-open .login-page .signup-panel,
  body.login-keyboard-open .login-page .legal-footer {
    display: none;
  }

  html.login-keyboard-open .login-page .login-top > h1,
  body.login-keyboard-open .login-page .login-top > h1 {
    font-size: 1.05rem;
    margin-bottom: 0;
  }

  html.login-keyboard-open .login-page .login-top,
  body.login-keyboard-open .login-page .login-top {
    margin-bottom: 8px;
  }

  html.login-keyboard-open .login-page-shell,
  body.login-keyboard-open .login-page-shell {
    /* Room to scroll the focused field clear of the keyboard feature bar. */
    gap: 0;
    padding-bottom: calc(var(--login-kb-bar, 64px) + 16px);
    scroll-padding-bottom: calc(var(--login-kb-bar, 64px) + 16px);
  }

  html.login-keyboard-open .login-page .login-form .input,
  html.login-keyboard-open .login-page .login-form .label,
  body.login-keyboard-open .login-page .login-form .input,
  body.login-keyboard-open .login-page .login-form .label {
    scroll-margin-bottom: calc(var(--login-kb-bar, 64px) + 20px);
  }

  html.login-keyboard-open .login-page .login-auth-card,
  body.login-keyboard-open .login-page .login-auth-card {
    padding: 12px 14px;
  }

  @media (max-height: 480px) {
    html.login-keyboard-open .login-page .landing-header,
    body.login-keyboard-open .login-page .landing-header {
      display: none;
    }
  }
}

@media (max-height: 520px) and (pointer: coarse) {
  html .login-page .landing-header {
    padding: 4px 12px;
  }

  html .login-page .header-logo {
    height: 28px;
    width: auto;
    max-width: 112px;
  }

  html .login-page .login-subtitle,
  html .login-page .login-mode-chip,
  html .login-page .legal-footer {
    display: none;
  }

  html .login-page .login-page-shell {
    padding: 4px 14px 2px;
    gap: 4px;
    max-width: none;
  }

  html .login-page .login-top {
    margin-bottom: 4px;
  }

  html .login-page .login-top > h1 {
    font-size: 1rem;
    line-height: 1.2;
    margin-bottom: 0;
  }

  html .login-page .login-auth-card {
    padding: 8px 12px;
  }

  html .login-page .login-form > .label {
    margin-bottom: 2px;
    font-size: 12px;
    line-height: 16px;
  }

  html .login-page .input {
    padding: 7px 12px;
    margin-bottom: 6px;
  }

  html .login-page .forgot-password {
    margin-bottom: 6px;
  }

  html .login-page .login-button {
    padding: 9px 14px;
  }

  html .login-page .signup-panel {
    padding: 6px 10px;
  }

  html .login-page .signup-panel__title {
    font-size: 0.95rem;
  }

  html .login-page .signup-button {
    padding: 8px 12px;
  }
}

@media (max-width: 768px) and (max-height: 740px) {
  .login-page .landing-header {
    padding: 6px 14px;
  }

  .login-page .header-logo {
    width: 112px;
  }

  .login-page .login-subtitle,
  .login-page .signup-panel__kicker,
  .login-page .signup-panel__text {
    display: none;
  }

  .login-page .login-mode-chip {
    margin-bottom: 6px;
    padding: 3px 8px;
    font-size: 10px;
  }

  .login-page .login-top {
    margin-bottom: 8px;
  }

  .login-page .login-top > h1 {
    font-size: 1.12rem;
    margin-bottom: 0;
  }

  .login-page .login-auth-card {
    padding: 12px 14px 14px;
    justify-content: flex-start;
  }

  .login-page .input {
    padding: 10px 12px;
    margin-bottom: 10px;
  }

  .login-page .forgot-password {
    margin-bottom: 10px;
  }

  .login-page .login-button {
    padding: 12px 16px;
  }

  .login-page .signup-panel {
    padding: 10px 12px;
  }
}

@media (min-width: 769px) and (max-height: 720px) {
  .login-page-shell {
    padding: 12px 32px 16px;
    gap: 18px;
  }

  .login-auth-card {
    padding: 18px 24px;
  }

  .signup-panel {
    padding: 20px 22px;
  }

  .login-page .login-top {
    margin-bottom: 10px;
  }

  .login-page .login-top > h1 {
    font-size: 1.3rem;
  }

  .login-page .input {
    padding: 10px 12px;
    margin-bottom: 10px;
  }

  .login-page .forgot-password {
    margin-bottom: 10px;
  }
}

/* Login Form Styles */
#LoginRoot {
  position: relative;
  display: flex;
  justify-content: center;
  border-radius: 4px;
  height: 100vh;
  color: #343339;
  margin: 0 auto;
  background: linear-gradient(135deg, #f8fafc 0%, #e2f2ff 100%);
}

#LoginRoot2 {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 680px;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  justify-content: center;
  border-radius: 20px;
  min-height: 90vh;
  color: #343339;
  margin: 5vh auto;
  background-color: #fff;
  padding: 0 15px;
  backdrop-filter: blur(10px);
  animation: slideIn 0.6s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.login-top {
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-top: 8vh;
  margin-bottom: 2vh;
}

.login-top-logo,
.login-top > img {
  margin-bottom: 24px;
  width: 220px;
  height: auto;
  object-fit: contain;
}

.login-top > h1 {
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
  color: #2D3748;
  margin-bottom: 8px;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.login-subtitle {
  font-size: 16px;
  color: #718096;
  font-weight: 400;
  margin: 0;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.login-form-div {
  margin: 0 3%;
  width: 94%;
}

.login-form {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
}

.login-form > .label {
  color: #4A5568;
  font-size: 14px;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  margin-bottom: 8px;
}

.input {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #F7FAFC;
  width: 100%;
  border-radius: 12px;
  border: 2px solid #E2E8F0;
  padding: 16px;
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.input:focus-within {
  border-color: var(--brand-primary);
  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb), 0.1);
  background-color: #fff;
}

.input > input {
  border: none;
  width: 100%;
  background-color: transparent;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  color: #2D3748;
}

/* Keep the designed field fill when the browser paints autofill (often light blue). */

.input:focus-within > input:-webkit-autofill,
.input:focus-within > input:-webkit-autofill:focus,
.input:focus-within > input:autofill {
  box-shadow: 0 0 0 1000px #fff inset;
  -webkit-box-shadow: 0 0 0 1000px #fff inset;
}

.input > input::placeholder {
  color: #A0AEC0;
}

.input > select {
  border: none;
  width: 100%;
  background-color: transparent;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.input > input:focus-visible {
  outline: none;
}

.input > select:focus-visible {
  outline: none;
}

.input > img {
  height: 18px;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.2s ease;
}

.input > img:hover {
  opacity: 1;
}


.forgot-password {
  text-align: right;
  margin-bottom: 32px;
  padding: 0 4px;
}

.forgot-password a {
  color: var(--brand-primary);
  font-size: 14px;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;
}

.forgot-password a:hover {
  color: var(--brand-primary-dark);
  text-decoration: underline;
}

.error-message {
  background-color: #FED7D7;
  color: #C53030;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  border: 1px solid #FEB2B2;
}

.session-expired-message {
  background-color: #BEE3F8;
  color: var(--brand-primary-dark);
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  font-size: 14px;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  border: 1px solid var(--brand-primary);
}

.login-button {
  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 16px 24px;
  font-size: 16px;
  font-weight: 600;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 32px;
  box-shadow: 0 4px 12px rgba(var(--brand-primary-rgb), 0.3);
}

.login-button:focus-visible {
  outline: 2px solid rgba(var(--brand-primary-rgb), 0.35);
  outline-offset: 2px;
}

.login-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(var(--brand-primary-rgb), 0.4);
}

.login-button:active:not(:disabled) {
  transform: translateY(0);
}

.login-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

.login-button svg {
  font-size: 18px;
}

.signup-link {
  text-align: center;
  padding: 24px 0;
  border-top: 1px solid #E2E8F0;
  margin-top: 16px;
}

.signup-link p {
  color: #4A5568;
  font-size: 14px;
  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  margin: 0;
}

.signup-link a {
  color: var(--brand-primary);
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s ease;
}

.signup-link a:hover {
  color: var(--brand-primary-dark);
  text-decoration: underline;
}

@media (min-width: 769px) and (max-width: 959px) {
  .landing-main {
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    padding: 20px 32px;
  }

  .welcome-section {
    text-align: center;
    max-width: 640px;
    flex: 0 1 auto;
  }

  .welcome-title {
    font-size: clamp(1.7rem, 3.2vw, 2.4rem);
  }
}

@media (min-width: 960px) and (max-width: 1024px) {
  .landing-main {
    gap: 28px;
    padding: 20px 32px;
  }

  .welcome-title {
    font-size: clamp(1.7rem, 3.2vw, 2.4rem);
  }
}

@media (min-width: 769px) and (max-height: 720px) {
  .landing-header {
    padding: 10px 32px;
  }

  .header-logo {
    width: 140px;
  }

  .landing-main {
    padding: 16px 32px;
    gap: 24px;
  }

  .landing-main::before,
  .landing-main::after {
    display: none;
  }

  .welcome-title {
    font-size: 1.85rem;
    margin-bottom: 6px;
  }

  .welcome-tagline {
    font-size: 1.05rem;
    margin-bottom: 8px;
  }

  .welcome-subtitle {
    font-size: 0.92rem;
  }

  .login-card {
    padding: 22px 24px;
  }

  .login-header {
    margin-bottom: 16px;
  }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .landing-container {
    flex-direction: column;
  }
  
  .hero-section {
    padding: 20px;
    min-height: 40vh;
  }
  
  .hero-title {
    font-size: 2.5rem;
  }
  
  .hero-features {
    gap: 20px;
  }
  
  .feature-item {
    padding: 15px;
  }
}

@media (max-width: 768px) {
  .hero-title {
    font-size: 2rem;
  }
  
  .hero-subtitle {
    font-size: 1.1rem;
  }
  
  .hero-features {
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }
  
  .landing-logo {
    width: 100px;
    padding: 12px;
  }
  
  #LoginRoot {
    flex-direction: column;
  }
  
  #LoginRoot2 {
    width: 100%;
    height: 100dvh;
    min-height: 100dvh;
    max-height: 100dvh;
    margin: 0;
    padding: 0 14px;
    padding-top: env(safe-area-inset-top, 0px);
    padding-bottom: env(safe-area-inset-bottom, 0px);
    border-radius: 0;
    box-shadow: none;
    overflow: hidden;
    justify-content: flex-start;
  }

  .login-top {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 12px;
    flex-shrink: 0;
  }

  .login-top-logo,
  .login-top > img {
    width: 200px;
    margin-bottom: 8px;
  }

  .login-top > h1 {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 4px;
  }

  .login-subtitle {
    font-size: 13px;
  }

  .login-form-div {
    flex: 1 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0;
    width: 100%;
  }

  .login-form {
    padding: 8px 0;
  }

  .login-form > .label {
    margin-bottom: 4px;
    font-size: 13px;
    line-height: 18px;
  }

  .input {
    padding: 11px 12px;
    margin-bottom: 12px;
  }

  .forgot-password {
    margin-bottom: 12px;
  }

  .error-message,
  .session-expired-message {
    margin-bottom: 12px;
    padding: 10px 12px;
    font-size: 13px;
  }

  .login-button {
    margin-bottom: 10px;
    padding: 12px 16px;
  }

  .signup-link {
    padding: 10px 0;
    margin-top: 4px;
    border-top: none;
  }
}

@media (max-width: 480px) {
  .hero-title {
    font-size: 1.75rem;
  }
  
  .welcome-text h2 {
    font-size: 1.5rem;
  }
  
  #LoginRoot2 {
    padding-left: 12px;
    padding-right: 12px;
  }

  .login-top-logo,
  .login-top > img {
    width: 180px;
    margin-bottom: 6px;
  }

  .login-top > h1 {
    font-size: 18px;
    line-height: 24px;
  }

  .login-subtitle {
    font-size: 12px;
  }

  .input {
    padding: 10px 12px;
    margin-bottom: 10px;
  }

  .login-button {
    padding: 11px 16px;
  }
}

@media (max-width: 768px) and (max-height: 700px) {
  .login-top {
    padding-top: 8px;
  }

  .login-top-logo,
  .login-top > img {
    width: 160px;
    margin-bottom: 4px;
  }

  .login-top > h1 {
    font-size: 17px;
    line-height: 22px;
  }

  .login-subtitle {
    font-size: 11px;
  }

  .login-form {
    padding: 4px 0;
  }

  .input {
    padding: 9px 10px;
    margin-bottom: 8px;
  }

  .forgot-password {
    margin-bottom: 8px;
  }

  .login-button {
    margin-bottom: 8px;
    padding: 10px 14px;
  }

  .signup-link {
    padding: 6px 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,qLAAqL;EACrL,0BAA0B;EAC1B,0CAA0C;EAC1C,uFAAuF;EACvF,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,MAAM,6BAA6B,EAAE;EACrC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;+FAG6F;EAC7F,gDAAgD;AAClD;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,2CAA2C,EAAE;EACnD,MAAM,0CAA0C,EAAE;AACpD;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,iDAAiD;EACjD,4BAA4B;EAC5B,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kFAAkF;EAClF,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,2CAA2C,EAAE;AACrD;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE,0CAA0C;EAC1C,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB;;;0CAGwC;EACxC,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,kBAAkB;EAClB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B;;;0CAGwC;AAC1C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;EAClB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,4FAA4F;EAC5F,YAAY;EACZ;;0CAEwC;EACxC,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B;;0CAEwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,0CAA0C;EAC1C;;0CAEwC;EACxC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,2BAA2B;EAC3B;;0CAEwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,0CAA0C;IAC1C,gDAAgD;EAClD;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,SAAO;IACP,sBAAsB;IACtB,aAAa;IACb,uBAAuB;IACvB,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,aAAa;IACb,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;IAC/B,yCAAyC;EAC3C;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,yCAAyC;IACzC,kBAAkB;EACpB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,wCAAwC;IACxC,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gFAAgF;AAChF;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,aAAa;EACb,aAAa;EACb,8DAA8D;EAC9D,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,cAAc;EACd,6EAA6E;EAC7E,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;EACf,2DAA2D;EAC3D,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,0DAA0D;EAC1D;;uCAEqC;EACrC,2CAA2C;EAC3C,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,wEAAwE;AACxE;EACE;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;IACpB,SAAS;EACX;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,2FAA2F;EAC3F,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT;;2CAEyC;EACzC,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kFAAkF;EAClF,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iFAAiF;EACjF,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;EAC3C,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uFAAuF;AACzF;;AAEA;EACE,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,uFAAuF;EACvF,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,uFAAuF;AACzF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uFAAuF;EACvF,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB;;sCAEoC;EACpC,yGAAyG;EACzG,yDAAyD;EACzD,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,uCAAuC;EACvC;;sCAEoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE;;yCAEqC;EACvC;EACA;IACE;;wCAEoC;EACtC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,uBAAuB;IACvB,SAAS;IACT,cAAc;EAChB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE;oFACgF;IAChF,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,oCAAoC;IACpC,+CAA+C;IAC/C,gBAAgB;IAChB,gCAAgC;IAChC,0CAA0C;IAC1C,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,WAAW;IACX,eAAe;IACf,uFAAuF;IACvF,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,4BAA4B;IAC5B,iCAAiC;IACjC,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;;;IAGE,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA,kEAAkE;EAClE;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,gBAAgB;EAClB;;EAEA;;;;;;;;IAQE,aAAa;EACf;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,wEAAwE;IACxE,MAAM;IACN,sDAAsD;IACtD,6DAA6D;EAC/D;;EAEA;;;;IAIE,4DAA4D;EAC9D;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE;;MAEE,aAAa;IACf;EACF;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,cAAc;EACd,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;EAC3C,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,uFAAuF;AACzF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,uFAAuF;AACzF;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uFAAuF;EACvF,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,uFAAuF;EACvF,eAAe;EACf,cAAc;AAChB;;AAEA,sFAAsF;;AAwBtF;;;EAGE,mCAAmC;EACnC,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,uFAAuF;AACzF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,uFAAuF;EACvF,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uFAAuF;EACvF,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uFAAuF;EACvF,sCAAsC;AACxC;;AAEA;EACE,4FAA4F;EAC5F,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,uFAAuF;EACvF,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,uDAAuD;EACvD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uFAAuF;EACvF,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,0CAA0C;IAC1C,gDAAgD;IAChD,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAO;IACP,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* Enhanced Landing Page Styles */\n.landing-container {\n  height: 100vh;\n  height: 100dvh;\n  min-height: 100dvh;\n  max-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 25%, var(--brand-primary-light) 50%, var(--brand-primary) 75%, var(--brand-primary-dark) 100%);\n  background-size: 400% 400%;\n  animation: gradientShift 15s ease infinite;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  position: relative;\n  overflow: hidden;\n}\n\n@keyframes gradientShift {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n.landing-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    radial-gradient(circle at 20% 80%, rgba(var(--brand-primary-rgb), 0.3) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(var(--brand-primary-rgb), 0.25) 0%, transparent 50%),\n    radial-gradient(circle at 40% 40%, rgba(var(--brand-primary-rgb), 0.3) 0%, transparent 50%);\n  animation: floatingOrbs 20s ease-in-out infinite;\n}\n\n@keyframes floatingOrbs {\n  0%, 100% { transform: translateY(0px) rotate(0deg); }\n  33% { transform: translateY(-20px) rotate(120deg); }\n  66% { transform: translateY(10px) rotate(240deg); }\n}\n\n.landing-header {\n  flex-shrink: 0;\n  padding: 14px 40px;\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(20px);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 0 0 20px 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  position: relative;\n  z-index: 10;\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.header-logo {\n  width: 168px;\n  height: auto;\n}\n\n.landing-main {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: clamp(32px, 5vw, 72px);\n  padding: 24px 48px;\n  text-align: center;\n  position: relative;\n  z-index: 5;\n  width: 100%;\n  max-width: 1180px;\n  margin: 0 auto;\n}\n\n.landing-main::before {\n  content: '';\n  position: absolute;\n  top: 10%;\n  left: 10%;\n  width: 200px;\n  height: 200px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);\n  border-radius: 50%;\n  animation: float 6s ease-in-out infinite;\n}\n\n.landing-main::after {\n  content: '';\n  position: absolute;\n  bottom: 20%;\n  right: 15%;\n  width: 150px;\n  height: 150px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%);\n  border-radius: 50%;\n  animation: float 8s ease-in-out infinite reverse;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px) rotate(0deg); }\n  50% { transform: translateY(-20px) rotate(180deg); }\n}\n\n.welcome-section {\n  margin-bottom: 0;\n  max-width: 540px;\n  flex: 1 1 0;\n  text-align: left;\n  position: relative;\n  z-index: 10;\n  animation: fadeInUp 1s ease-out;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.welcome-title {\n  font-size: clamp(2rem, 3.6vw, 3.1rem);\n  font-weight: 800;\n  color: white;\n  margin-bottom: 10px;\n  line-height: 1.12;\n  white-space: normal;\n  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  background: linear-gradient(135deg, #ffffff 0%, #f0f9ff 50%, #e0f2fe 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  animation: titleGlow 3s ease-in-out infinite alternate;\n}\n\n.welcome-tagline {\n  font-size: clamp(1.05rem, 1.8vw, 1.45rem);\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  color: rgba(255, 255, 255, 0.96);\n  margin: 0 0 14px;\n  line-height: 1.35;\n  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.25);\n  animation: fadeInUp 1s ease-out 0.15s both;\n}\n\n@keyframes titleGlow {\n  from {\n    text-shadow: 0 4px 20px rgba(255, 255, 255, 0.3);\n  }\n  to {\n    text-shadow: 0 8px 30px rgba(255, 255, 255, 0.6);\n  }\n}\n\n.welcome-subtitle {\n  font-size: clamp(0.95rem, 1.25vw, 1.15rem);\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1.55;\n  font-weight: 400;\n  margin: 0;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  animation: fadeInUp 1s ease-out 0.3s both;\n}\n\n.login-card {\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(25px);\n  border-radius: 24px;\n  padding: 32px 28px;\n  box-shadow: \n    0 25px 50px rgba(0, 0, 0, 0.15),\n    0 0 0 1px rgba(255, 255, 255, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  width: 100%;\n  max-width: 420px;\n  flex-shrink: 0;\n  animation: slideInUp 1s ease-out;\n  position: relative;\n  z-index: 10;\n  transition: all 0.3s ease;\n}\n\n.login-card:hover {\n  transform: translateY(-5px);\n  box-shadow: \n    0 35px 70px rgba(0, 0, 0, 0.2),\n    0 0 0 1px rgba(255, 255, 255, 0.3),\n    inset 0 1px 0 rgba(255, 255, 255, 0.4);\n}\n\n@keyframes slideInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.language-selector {\n  text-align: right;\n}\n\n.lang-select {\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid #E2E8F0;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 14px;\n  color: #4A5568;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.lang-select:focus {\n  outline: none;\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb), 0.1);\n}\n\n.login-header {\n  text-align: center;\n  margin-bottom: 30px;\n}\n\n.login-header h2 {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: white;\n  margin-bottom: 8px;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.login-header p {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 0.95rem;\n  margin: 0;\n  text-shadow: 0 1px 5px rgba(0, 0, 0, 0.15);\n}\n\n.login-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.login-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n}\n\n.primary-btn {\n  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);\n  color: white;\n  box-shadow: \n    0 8px 25px rgba(var(--brand-primary-rgb), 0.4),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  position: relative;\n  overflow: hidden;\n}\n\n.primary-btn:focus-visible {\n  outline: 2px solid rgba(var(--brand-primary-rgb), 0.35);\n  outline-offset: 2px;\n}\n\n.primary-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s;\n}\n\n.primary-btn:hover::before {\n  left: 100%;\n}\n\n.primary-btn:hover {\n  transform: translateY(-3px);\n  box-shadow: \n    0 12px 35px rgba(var(--brand-primary-rgb), 0.5),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.social-login {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.social-btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  box-shadow: \n    0 4px 15px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(10px);\n  transition: all 0.3s ease;\n}\n\n.social-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  border-color: rgba(255, 255, 255, 0.5);\n  transform: translateY(-2px);\n  box-shadow: \n    0 8px 25px rgba(0, 0, 0, 0.15),\n    inset 0 1px 0 rgba(255, 255, 255, 0.3);\n}\n\n.social-btn img {\n  width: 20px;\n  height: 20px;\n}\n\n.btn-icon {\n  font-size: 18px;\n}\n\n.landing-footer {\n  text-align: center;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.landing-footer p {\n  color: #A0AEC0;\n  font-size: 14px;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .landing-container {\n    height: 100dvh;\n    min-height: 100dvh;\n    max-height: 100dvh;\n    overflow: hidden;\n    padding-top: env(safe-area-inset-top, 0px);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n\n  .landing-header {\n    flex-shrink: 0;\n    padding: 10px 16px;\n    border-radius: 0 0 12px 12px;\n  }\n  \n  .header-content {\n    flex-direction: row;\n    gap: 12px;\n  }\n\n  .header-logo {\n    width: 140px;\n  }\n  \n  .landing-main {\n    flex: 1;\n    flex-direction: column;\n    min-height: 0;\n    padding: 12px 16px 16px;\n    justify-content: space-evenly;\n    gap: 12px;\n    overflow: hidden;\n    max-width: none;\n  }\n  \n  .landing-main::before,\n  .landing-main::after {\n    display: none;\n  }\n\n  .welcome-section {\n    margin-bottom: 0;\n    flex: 0 1 auto;\n    flex-shrink: 1;\n    min-height: 0;\n    max-width: 100%;\n    text-align: center;\n  }\n  \n  .welcome-title {\n    font-size: clamp(1.25rem, 5vw, 1.7rem);\n    margin-bottom: 6px;\n    line-height: 1.2;\n  }\n\n  .welcome-tagline {\n    font-size: clamp(0.88rem, 3.4vw, 1.05rem);\n    margin-bottom: 8px;\n  }\n  \n  .welcome-subtitle {\n    font-size: clamp(0.8rem, 3.2vw, 0.92rem);\n    line-height: 1.4;\n  }\n  \n  .login-card {\n    padding: 18px 16px;\n    max-width: 100%;\n    border-radius: 16px;\n    flex-shrink: 0;\n  }\n\n  .login-card:hover {\n    transform: none;\n  }\n  \n  .login-header {\n    margin-bottom: 14px;\n  }\n\n  .login-header h2 {\n    font-size: 1.15rem;\n    margin-bottom: 4px;\n    color: white;\n    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n  }\n  \n  .login-header p {\n    font-size: 0.85rem;\n    color: rgba(255, 255, 255, 0.8);\n    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.1);\n  }\n\n  .login-buttons {\n    gap: 10px;\n  }\n\n  .login-btn {\n    padding: 12px 16px;\n    font-size: 14px;\n  }\n  \n  .landing-footer {\n    margin-top: 12px;\n    padding-top: 10px;\n  }\n\n  .landing-footer p {\n    font-size: 11px;\n  }\n\n  .lang-select {\n    padding: 6px 8px;\n    font-size: 12px;\n  }\n}\n\n@media (max-width: 480px) {\n  .landing-header {\n    padding: 8px 12px;\n  }\n  \n  .header-logo {\n    width: 128px;\n  }\n  \n  .welcome-title {\n    font-size: clamp(1.1rem, 4.8vw, 1.4rem);\n  }\n\n  .welcome-tagline {\n    font-size: clamp(0.82rem, 3.4vw, 0.95rem);\n    margin-bottom: 6px;\n  }\n\n  .welcome-subtitle {\n    font-size: clamp(0.75rem, 3.1vw, 0.85rem);\n  }\n  \n  .login-card {\n    padding: 14px 14px;\n  }\n  \n  .login-header h2 {\n    font-size: 1.05rem;\n  }\n}\n\n@media (max-width: 768px) and (max-height: 700px) {\n  .landing-main {\n    padding: 8px 14px 12px;\n  }\n\n  .welcome-title {\n    font-size: clamp(1.05rem, 4.4vw, 1.3rem);\n    line-height: 1.2;\n  }\n\n  .welcome-tagline {\n    font-size: 0.85rem;\n    margin-bottom: 4px;\n  }\n\n  .welcome-subtitle {\n    font-size: 0.78rem;\n    line-height: 1.3;\n  }\n\n  .login-card {\n    padding: 12px 14px;\n  }\n\n  .login-header {\n    margin-bottom: 10px;\n  }\n\n  .landing-footer {\n    margin-top: 8px;\n    padding-top: 8px;\n  }\n}\n\n/* Login page — viewport-fit PC split (login vs signup) */\n.login-page-logo {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n}\n\n.login-page-logo:focus-visible {\n  outline: 2px solid rgba(255, 255, 255, 0.7);\n  outline-offset: 4px;\n  border-radius: 8px;\n}\n\n/* Login page: fit viewport at any browser zoom — never clip the submit button */\n.login-page.landing-container {\n  height: 100dvh;\n  min-height: 100dvh;\n  max-height: none;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.login-page .landing-header {\n  padding: clamp(8px, 1.4vh, 14px) clamp(16px, 3vw, 40px);\n}\n\n.login-page .header-logo {\n  width: clamp(120px, 18vw, 168px);\n}\n\n.login-page-shell {\n  flex: 1 0 auto;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: minmax(0, 1.15fr) minmax(240px, 0.85fr);\n  gap: clamp(12px, 2.5vh, 36px);\n  align-items: start;\n  width: 100%;\n  max-width: min(980px, 100%);\n  margin: 0 auto;\n  padding: clamp(10px, 2vh, 20px) clamp(16px, 3vw, 40px) clamp(16px, 3vh, 28px);\n  position: relative;\n  z-index: 5;\n  box-sizing: border-box;\n}\n\n.login-auth-card,\n.signup-panel {\n  position: relative;\n  z-index: 10;\n  min-height: 0;\n  min-width: 0;\n  max-width: 100%;\n  animation: fadeInUp 0.7s cubic-bezier(0.25, 1, 0.5, 1) both;\n  box-sizing: border-box;\n}\n\n.signup-panel {\n  animation-delay: 0.12s;\n}\n\n.login-auth-card {\n  background: rgba(255, 255, 255, 0.94);\n  backdrop-filter: blur(22px);\n  -webkit-backdrop-filter: blur(22px);\n  border-radius: 24px;\n  padding: clamp(16px, 2.4vh, 28px) clamp(16px, 2.5vw, 32px);\n  box-shadow:\n    0 22px 48px rgba(0, 0, 0, 0.16),\n    0 0 0 1px rgba(255, 255, 255, 0.45);\n  border: 1px solid rgba(255, 255, 255, 0.55);\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.login-page .login-top {\n  width: 100%;\n  margin: 0 0 clamp(10px, 1.6vh, 18px);\n  align-items: flex-start;\n  text-align: left;\n}\n\n.login-page .login-top > h1 {\n  font-size: clamp(1.15rem, 1.8vw + 0.4vh, 1.7rem);\n  line-height: 1.25;\n  margin-bottom: 6px;\n  color: #1A365D;\n}\n\n.login-page .login-subtitle {\n  font-size: clamp(0.82rem, 1.1vw, 0.95rem);\n  color: #4A5568;\n  line-height: 1.4;\n}\n\n.login-page .login-form-div {\n  margin: 0;\n  width: 100%;\n}\n\n.login-page .login-form {\n  padding: 0;\n}\n\n.login-page .login-form > .label {\n  margin-bottom: 4px;\n  font-size: 13px;\n  line-height: 18px;\n}\n\n.login-page .input {\n  padding: clamp(10px, 1.4vh, 12px) 14px;\n  margin-bottom: clamp(8px, 1.4vh, 14px);\n}\n\n.login-page .forgot-password {\n  margin-bottom: clamp(10px, 1.6vh, 16px);\n}\n\n.login-page .error-message,\n.login-page .session-expired-message {\n  margin-bottom: 12px;\n  padding: 10px 12px;\n}\n\n.login-page .login-button {\n  margin-bottom: 0;\n  margin-top: 4px;\n  padding: clamp(12px, 1.6vh, 14px) 20px;\n  font-size: 15px;\n  letter-spacing: 0.01em;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.login-page .login-button:hover:not(:disabled) {\n  transform: translateY(-2px) scale(1.01);\n}\n\n.login-page .login-button:active:not(:disabled) {\n  transform: scale(0.98);\n}\n\n/* Short desktop viewports / zoomed browsers: keep login CTA reachable */\n@media (min-width: 960px) and (max-height: 820px) {\n  .login-page .landing-header {\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n\n  .login-page-shell {\n    padding-top: 10px;\n    padding-bottom: 16px;\n    gap: 14px;\n  }\n\n  .login-auth-card,\n  .signup-panel {\n    padding: 16px 20px;\n  }\n\n  .login-page .login-top {\n    margin-bottom: 10px;\n  }\n\n  .login-mode-chip {\n    margin-bottom: 6px;\n  }\n\n  .login-page .input {\n    margin-bottom: 8px;\n    padding: 10px 12px;\n  }\n\n  .signup-panel__title {\n    font-size: 1.25rem;\n  }\n\n  .signup-panel__text {\n    font-size: 0.88rem;\n  }\n}\n\n@media (min-width: 960px) and (max-height: 700px) {\n  .login-page-shell {\n    grid-template-columns: minmax(0, 1fr) minmax(220px, 0.75fr);\n  }\n\n  .login-page .login-top > h1 {\n    font-size: 1.2rem;\n  }\n\n  .login-page .login-subtitle {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n}\n\n.password-toggle {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 4px;\n  margin-left: 8px;\n  cursor: pointer;\n  border-radius: 8px;\n  color: #718096;\n}\n\n.password-toggle img {\n  height: 18px;\n  width: 18px;\n  opacity: 0.7;\n}\n\n.password-toggle:hover img {\n  opacity: 1;\n}\n\n.password-toggle:focus-visible {\n  outline: 2px solid rgba(var(--brand-primary-rgb), 0.35);\n  outline-offset: 2px;\n}\n\n.signup-panel {\n  background: linear-gradient(165deg, var(--brand-primary) 0%, var(--brand-primary-dark) 78%);\n  border-radius: 24px;\n  padding: 32px 28px;\n  color: #fff;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  gap: 10px;\n  box-shadow:\n    0 22px 48px rgba(0, 0, 0, 0.2),\n    inset 0 1px 0 rgba(255, 255, 255, 0.22);\n  border: 1px solid rgba(255, 255, 255, 0.22);\n  overflow: hidden;\n}\n\n.signup-panel::before {\n  content: '';\n  position: absolute;\n  top: -40px;\n  right: -30px;\n  width: 160px;\n  height: 160px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.18) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.signup-panel::after {\n  content: '';\n  position: absolute;\n  bottom: -50px;\n  left: -20px;\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.signup-panel__kicker {\n  display: inline-flex;\n  margin: 0;\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.16);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.signup-panel__title {\n  margin: 4px 0 0;\n  font-size: clamp(1.45rem, 2.2vw, 1.9rem);\n  font-weight: 800;\n  line-height: 1.2;\n  letter-spacing: -0.02em;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.18);\n}\n\n.signup-panel__text {\n  margin: 0 0 8px;\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.9);\n  max-width: 28ch;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.signup-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  margin-top: 8px;\n  padding: 14px 20px;\n  border-radius: 12px;\n  font-size: 16px;\n  font-weight: 700;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  text-decoration: none;\n  color: var(--brand-primary-dark);\n  background: #fff;\n  box-shadow:\n    0 10px 28px rgba(0, 0, 0, 0.18),\n    0 0 0 1px rgba(255, 255, 255, 0.5);\n  transition: transform 0.35s cubic-bezier(0.25, 1, 0.5, 1), box-shadow 0.35s cubic-bezier(0.25, 1, 0.5, 1);\n  animation: signupGlow 2.8s ease-in-out infinite alternate;\n  position: relative;\n  z-index: 1;\n}\n\n.signup-button:hover {\n  transform: translateY(-2px) scale(1.02);\n  box-shadow:\n    0 16px 36px rgba(0, 0, 0, 0.22),\n    0 0 0 1px rgba(255, 255, 255, 0.7);\n}\n\n.signup-button:active {\n  transform: scale(0.98);\n}\n\n.signup-button:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 3px;\n}\n\n@keyframes signupGlow {\n  from {\n    box-shadow:\n      0 10px 28px rgba(0, 0, 0, 0.18),\n      0 0 0 1px rgba(255, 255, 255, 0.45);\n  }\n  to {\n    box-shadow:\n      0 12px 34px rgba(255, 255, 255, 0.28),\n      0 0 0 1px rgba(255, 255, 255, 0.7);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .signup-button {\n    animation: none;\n  }\n\n  .login-auth-card,\n  .signup-panel {\n    animation: none;\n  }\n}\n\n@media (max-width: 959px) {\n  .login-page-shell {\n    grid-template-columns: 1fr;\n    max-width: 520px;\n    padding: 16px 24px 24px;\n    gap: 16px;\n    overflow: auto;\n  }\n\n  .login-auth-card,\n  .signup-panel {\n    padding: 22px 22px;\n  }\n\n  .signup-panel {\n    align-items: stretch;\n    text-align: left;\n  }\n\n  .signup-panel__text {\n    max-width: none;\n  }\n}\n\n@media (max-width: 768px), (max-height: 520px) and (pointer: coarse) {\n  html:has(.login-page),\n  body:has(.login-page) {\n    height: 100%;\n    overflow: hidden;\n    overscroll-behavior: none;\n  }\n\n  .login-page.landing-container {\n    /* Follow the visual viewport. The page fills that box; the keyboard\n       feature bar is kept clear by padding and scroll, not by a hole in the page. */\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: var(--login-vvh, 100dvh);\n    min-height: 0;\n    max-height: var(--login-vvh, 100dvh);\n    transform: translateY(var(--login-vv-top, 0px));\n    overflow: hidden;\n    -webkit-overflow-scrolling: auto;\n    padding-top: env(safe-area-inset-top, 0px);\n    padding-bottom: 0;\n    box-sizing: border-box;\n  }\n\n  .login-page .landing-header {\n    padding: 8px 14px;\n  }\n\n  .login-page .header-logo {\n    width: auto;\n    height: 40px;\n    max-width: 148px;\n    object-fit: contain;\n  }\n\n  .login-page-shell {\n    display: flex;\n    flex-direction: column;\n    flex: 1 1 auto;\n    min-height: 0;\n    width: 100%;\n    max-width: none;\n    padding: 8px 16px max(12px, var(--login-safe-bottom, env(safe-area-inset-bottom, 0px)));\n    gap: 10px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n    -webkit-overflow-scrolling: touch;\n    align-content: stretch;\n    justify-content: flex-start;\n    scroll-padding-top: 8px;\n    scroll-padding-bottom: 16px;\n  }\n\n  .login-auth-card {\n    flex: 0 0 auto;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    padding: 14px 16px 16px;\n    border-radius: 18px;\n    overflow: visible;\n  }\n\n  .login-page .login-form-div {\n    flex: 0 0 auto;\n  }\n\n  .login-page .login-form .input,\n  .login-page .login-form .label,\n  .login-page .login-button {\n    scroll-margin-top: 12px;\n    scroll-margin-bottom: 16px;\n  }\n\n  .login-page .legal-footer {\n    margin-top: 10px;\n    font-size: 11px;\n    line-height: 1.35;\n    gap: 0.2rem 0.45rem;\n  }\n\n  .login-page .input {\n    margin-bottom: 10px;\n  }\n\n  .login-page .forgot-password {\n    margin-bottom: 10px;\n  }\n\n  .login-page .login-top {\n    margin-bottom: 12px;\n    align-items: center;\n    text-align: center;\n    flex-shrink: 0;\n  }\n\n  .login-page .login-top > h1 {\n    font-size: 1.28rem;\n  }\n\n  .login-page .login-subtitle {\n    font-size: 0.82rem;\n  }\n\n  .login-mode-chip {\n    align-self: center;\n  }\n\n  .signup-panel {\n    flex: 0 0 auto;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px 12px;\n    padding: 12px 14px;\n    border-radius: 16px;\n  }\n\n  .signup-panel::before,\n  .signup-panel::after {\n    display: none;\n  }\n\n  .signup-panel__kicker {\n    display: none;\n  }\n\n  .signup-panel__title {\n    flex: 1 1 auto;\n    font-size: 1.05rem;\n    margin: 0;\n  }\n\n  .signup-panel__text {\n    display: none;\n  }\n\n  .signup-button {\n    width: auto;\n    min-width: 7.5rem;\n    margin-top: 0;\n    padding: 10px 16px;\n    font-size: 14px;\n    animation: none;\n  }\n\n  /* Keyboard open: collapse chrome so email/password stay in view */\n  html.login-keyboard-open .login-page .landing-header,\n  body.login-keyboard-open .login-page .landing-header {\n    padding: 4px 12px;\n  }\n\n  html.login-keyboard-open .login-page .header-logo,\n  body.login-keyboard-open .login-page .header-logo {\n    width: auto;\n    height: 28px;\n    max-width: 108px;\n  }\n\n  html.login-keyboard-open .login-page .login-subtitle,\n  html.login-keyboard-open .login-page .login-mode-chip,\n  html.login-keyboard-open .login-page .signup-panel,\n  html.login-keyboard-open .login-page .legal-footer,\n  body.login-keyboard-open .login-page .login-subtitle,\n  body.login-keyboard-open .login-page .login-mode-chip,\n  body.login-keyboard-open .login-page .signup-panel,\n  body.login-keyboard-open .login-page .legal-footer {\n    display: none;\n  }\n\n  html.login-keyboard-open .login-page .login-top > h1,\n  body.login-keyboard-open .login-page .login-top > h1 {\n    font-size: 1.05rem;\n    margin-bottom: 0;\n  }\n\n  html.login-keyboard-open .login-page .login-top,\n  body.login-keyboard-open .login-page .login-top {\n    margin-bottom: 8px;\n  }\n\n  html.login-keyboard-open .login-page-shell,\n  body.login-keyboard-open .login-page-shell {\n    /* Room to scroll the focused field clear of the keyboard feature bar. */\n    gap: 0;\n    padding-bottom: calc(var(--login-kb-bar, 64px) + 16px);\n    scroll-padding-bottom: calc(var(--login-kb-bar, 64px) + 16px);\n  }\n\n  html.login-keyboard-open .login-page .login-form .input,\n  html.login-keyboard-open .login-page .login-form .label,\n  body.login-keyboard-open .login-page .login-form .input,\n  body.login-keyboard-open .login-page .login-form .label {\n    scroll-margin-bottom: calc(var(--login-kb-bar, 64px) + 20px);\n  }\n\n  html.login-keyboard-open .login-page .login-auth-card,\n  body.login-keyboard-open .login-page .login-auth-card {\n    padding: 12px 14px;\n  }\n\n  @media (max-height: 480px) {\n    html.login-keyboard-open .login-page .landing-header,\n    body.login-keyboard-open .login-page .landing-header {\n      display: none;\n    }\n  }\n}\n\n@media (max-height: 520px) and (pointer: coarse) {\n  html .login-page .landing-header {\n    padding: 4px 12px;\n  }\n\n  html .login-page .header-logo {\n    height: 28px;\n    width: auto;\n    max-width: 112px;\n  }\n\n  html .login-page .login-subtitle,\n  html .login-page .login-mode-chip,\n  html .login-page .legal-footer {\n    display: none;\n  }\n\n  html .login-page .login-page-shell {\n    padding: 4px 14px 2px;\n    gap: 4px;\n    max-width: none;\n  }\n\n  html .login-page .login-top {\n    margin-bottom: 4px;\n  }\n\n  html .login-page .login-top > h1 {\n    font-size: 1rem;\n    line-height: 1.2;\n    margin-bottom: 0;\n  }\n\n  html .login-page .login-auth-card {\n    padding: 8px 12px;\n  }\n\n  html .login-page .login-form > .label {\n    margin-bottom: 2px;\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  html .login-page .input {\n    padding: 7px 12px;\n    margin-bottom: 6px;\n  }\n\n  html .login-page .forgot-password {\n    margin-bottom: 6px;\n  }\n\n  html .login-page .login-button {\n    padding: 9px 14px;\n  }\n\n  html .login-page .signup-panel {\n    padding: 6px 10px;\n  }\n\n  html .login-page .signup-panel__title {\n    font-size: 0.95rem;\n  }\n\n  html .login-page .signup-button {\n    padding: 8px 12px;\n  }\n}\n\n@media (max-width: 768px) and (max-height: 740px) {\n  .login-page .landing-header {\n    padding: 6px 14px;\n  }\n\n  .login-page .header-logo {\n    width: 112px;\n  }\n\n  .login-page .login-subtitle,\n  .login-page .signup-panel__kicker,\n  .login-page .signup-panel__text {\n    display: none;\n  }\n\n  .login-page .login-mode-chip {\n    margin-bottom: 6px;\n    padding: 3px 8px;\n    font-size: 10px;\n  }\n\n  .login-page .login-top {\n    margin-bottom: 8px;\n  }\n\n  .login-page .login-top > h1 {\n    font-size: 1.12rem;\n    margin-bottom: 0;\n  }\n\n  .login-page .login-auth-card {\n    padding: 12px 14px 14px;\n    justify-content: flex-start;\n  }\n\n  .login-page .input {\n    padding: 10px 12px;\n    margin-bottom: 10px;\n  }\n\n  .login-page .forgot-password {\n    margin-bottom: 10px;\n  }\n\n  .login-page .login-button {\n    padding: 12px 16px;\n  }\n\n  .login-page .signup-panel {\n    padding: 10px 12px;\n  }\n}\n\n@media (min-width: 769px) and (max-height: 720px) {\n  .login-page-shell {\n    padding: 12px 32px 16px;\n    gap: 18px;\n  }\n\n  .login-auth-card {\n    padding: 18px 24px;\n  }\n\n  .signup-panel {\n    padding: 20px 22px;\n  }\n\n  .login-page .login-top {\n    margin-bottom: 10px;\n  }\n\n  .login-page .login-top > h1 {\n    font-size: 1.3rem;\n  }\n\n  .login-page .input {\n    padding: 10px 12px;\n    margin-bottom: 10px;\n  }\n\n  .login-page .forgot-password {\n    margin-bottom: 10px;\n  }\n}\n\n/* Login Form Styles */\n#LoginRoot {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  border-radius: 4px;\n  height: 100vh;\n  color: #343339;\n  margin: 0 auto;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2f2ff 100%);\n}\n\n#LoginRoot2 {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 680px;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);\n  justify-content: center;\n  border-radius: 20px;\n  min-height: 90vh;\n  color: #343339;\n  margin: 5vh auto;\n  background-color: #fff;\n  padding: 0 15px;\n  backdrop-filter: blur(10px);\n  animation: slideIn 0.6s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.login-top {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  margin-top: 8vh;\n  margin-bottom: 2vh;\n}\n\n.login-top-logo,\n.login-top > img {\n  margin-bottom: 24px;\n  width: 220px;\n  height: auto;\n  object-fit: contain;\n}\n\n.login-top > h1 {\n  font-size: 28px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 36px;\n  color: #2D3748;\n  margin-bottom: 8px;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.login-subtitle {\n  font-size: 16px;\n  color: #718096;\n  font-weight: 400;\n  margin: 0;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.login-form-div {\n  margin: 0 3%;\n  width: 94%;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0;\n}\n\n.login-form > .label {\n  color: #4A5568;\n  font-size: 14px;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 22px;\n  margin-bottom: 8px;\n}\n\n.input {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #F7FAFC;\n  width: 100%;\n  border-radius: 12px;\n  border: 2px solid #E2E8F0;\n  padding: 16px;\n  margin-bottom: 24px;\n  transition: all 0.3s ease;\n}\n\n.input:focus-within {\n  border-color: var(--brand-primary);\n  box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb), 0.1);\n  background-color: #fff;\n}\n\n.input > input {\n  border: none;\n  width: 100%;\n  background-color: transparent;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: 16px;\n  color: #2D3748;\n}\n\n/* Keep the designed field fill when the browser paints autofill (often light blue). */\n.input > input:-webkit-autofill,\n.input > input:-webkit-autofill:hover,\n.input > input:-webkit-autofill:focus,\n.input > input:-webkit-autofill:active,\n.input > input:autofill {\n  -webkit-text-fill-color: #2D3748;\n  caret-color: #2D3748;\n  border: none;\n  transition: background-color 99999s ease-out;\n  box-shadow: 0 0 0 1000px #F7FAFC inset;\n  -webkit-box-shadow: 0 0 0 1000px #F7FAFC inset;\n}\n\n.input:has(> input:-webkit-autofill),\n.input:has(> input:autofill) {\n  background-color: #F7FAFC;\n}\n\n.input:focus-within:has(> input:-webkit-autofill),\n.input:focus-within:has(> input:autofill) {\n  background-color: #fff;\n}\n\n.input:focus-within > input:-webkit-autofill,\n.input:focus-within > input:-webkit-autofill:focus,\n.input:focus-within > input:autofill {\n  box-shadow: 0 0 0 1000px #fff inset;\n  -webkit-box-shadow: 0 0 0 1000px #fff inset;\n}\n\n.input > input::placeholder {\n  color: #A0AEC0;\n}\n\n.input > select {\n  border: none;\n  width: 100%;\n  background-color: transparent;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n}\n\n.input > input:focus-visible {\n  outline: none;\n}\n\n.input > select:focus-visible {\n  outline: none;\n}\n\n.input > img {\n  height: 18px;\n  cursor: pointer;\n  opacity: 0.6;\n  transition: opacity 0.2s ease;\n}\n\n.input > img:hover {\n  opacity: 1;\n}\n\n\n.forgot-password {\n  text-align: right;\n  margin-bottom: 32px;\n  padding: 0 4px;\n}\n\n.forgot-password a {\n  color: var(--brand-primary);\n  font-size: 14px;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-weight: 500;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.forgot-password a:hover {\n  color: var(--brand-primary-dark);\n  text-decoration: underline;\n}\n\n.error-message {\n  background-color: #FED7D7;\n  color: #C53030;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  border: 1px solid #FEB2B2;\n}\n\n.session-expired-message {\n  background-color: #BEE3F8;\n  color: var(--brand-primary-dark);\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 24px;\n  font-size: 14px;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  border: 1px solid var(--brand-primary);\n}\n\n.login-button {\n  background: linear-gradient(135deg, var(--brand-primary) 0%, var(--brand-primary-dark) 100%);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  padding: 16px 24px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 32px;\n  box-shadow: 0 4px 12px rgba(var(--brand-primary-rgb), 0.3);\n}\n\n.login-button:focus-visible {\n  outline: 2px solid rgba(var(--brand-primary-rgb), 0.35);\n  outline-offset: 2px;\n}\n\n.login-button:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(var(--brand-primary-rgb), 0.4);\n}\n\n.login-button:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.login-button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.login-button svg {\n  font-size: 18px;\n}\n\n.signup-link {\n  text-align: center;\n  padding: 24px 0;\n  border-top: 1px solid #E2E8F0;\n  margin-top: 16px;\n}\n\n.signup-link p {\n  color: #4A5568;\n  font-size: 14px;\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  margin: 0;\n}\n\n.signup-link a {\n  color: var(--brand-primary);\n  font-weight: 600;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n\n.signup-link a:hover {\n  color: var(--brand-primary-dark);\n  text-decoration: underline;\n}\n\n@media (min-width: 769px) and (max-width: 959px) {\n  .landing-main {\n    flex-direction: column;\n    justify-content: center;\n    gap: 20px;\n    padding: 20px 32px;\n  }\n\n  .welcome-section {\n    text-align: center;\n    max-width: 640px;\n    flex: 0 1 auto;\n  }\n\n  .welcome-title {\n    font-size: clamp(1.7rem, 3.2vw, 2.4rem);\n  }\n}\n\n@media (min-width: 960px) and (max-width: 1024px) {\n  .landing-main {\n    gap: 28px;\n    padding: 20px 32px;\n  }\n\n  .welcome-title {\n    font-size: clamp(1.7rem, 3.2vw, 2.4rem);\n  }\n}\n\n@media (min-width: 769px) and (max-height: 720px) {\n  .landing-header {\n    padding: 10px 32px;\n  }\n\n  .header-logo {\n    width: 140px;\n  }\n\n  .landing-main {\n    padding: 16px 32px;\n    gap: 24px;\n  }\n\n  .landing-main::before,\n  .landing-main::after {\n    display: none;\n  }\n\n  .welcome-title {\n    font-size: 1.85rem;\n    margin-bottom: 6px;\n  }\n\n  .welcome-tagline {\n    font-size: 1.05rem;\n    margin-bottom: 8px;\n  }\n\n  .welcome-subtitle {\n    font-size: 0.92rem;\n  }\n\n  .login-card {\n    padding: 22px 24px;\n  }\n\n  .login-header {\n    margin-bottom: 16px;\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .landing-container {\n    flex-direction: column;\n  }\n  \n  .hero-section {\n    padding: 20px;\n    min-height: 40vh;\n  }\n  \n  .hero-title {\n    font-size: 2.5rem;\n  }\n  \n  .hero-features {\n    gap: 20px;\n  }\n  \n  .feature-item {\n    padding: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .hero-title {\n    font-size: 2rem;\n  }\n  \n  .hero-subtitle {\n    font-size: 1.1rem;\n  }\n  \n  .hero-features {\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n  }\n  \n  .landing-logo {\n    width: 100px;\n    padding: 12px;\n  }\n  \n  #LoginRoot {\n    flex-direction: column;\n  }\n  \n  #LoginRoot2 {\n    width: 100%;\n    height: 100dvh;\n    min-height: 100dvh;\n    max-height: 100dvh;\n    margin: 0;\n    padding: 0 14px;\n    padding-top: env(safe-area-inset-top, 0px);\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n    border-radius: 0;\n    box-shadow: none;\n    overflow: hidden;\n    justify-content: flex-start;\n  }\n\n  .login-top {\n    margin-top: 0;\n    margin-bottom: 0;\n    padding-top: 12px;\n    flex-shrink: 0;\n  }\n\n  .login-top-logo,\n  .login-top > img {\n    width: 200px;\n    margin-bottom: 8px;\n  }\n\n  .login-top > h1 {\n    font-size: 20px;\n    line-height: 26px;\n    margin-bottom: 4px;\n  }\n\n  .login-subtitle {\n    font-size: 13px;\n  }\n\n  .login-form-div {\n    flex: 1;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    margin: 0;\n    width: 100%;\n  }\n\n  .login-form {\n    padding: 8px 0;\n  }\n\n  .login-form > .label {\n    margin-bottom: 4px;\n    font-size: 13px;\n    line-height: 18px;\n  }\n\n  .input {\n    padding: 11px 12px;\n    margin-bottom: 12px;\n  }\n\n  .forgot-password {\n    margin-bottom: 12px;\n  }\n\n  .error-message,\n  .session-expired-message {\n    margin-bottom: 12px;\n    padding: 10px 12px;\n    font-size: 13px;\n  }\n\n  .login-button {\n    margin-bottom: 10px;\n    padding: 12px 16px;\n  }\n\n  .signup-link {\n    padding: 10px 0;\n    margin-top: 4px;\n    border-top: none;\n  }\n}\n\n@media (max-width: 480px) {\n  .hero-title {\n    font-size: 1.75rem;\n  }\n  \n  .welcome-text h2 {\n    font-size: 1.5rem;\n  }\n  \n  #LoginRoot2 {\n    padding-left: 12px;\n    padding-right: 12px;\n  }\n\n  .login-top-logo,\n  .login-top > img {\n    width: 180px;\n    margin-bottom: 6px;\n  }\n\n  .login-top > h1 {\n    font-size: 18px;\n    line-height: 24px;\n  }\n\n  .login-subtitle {\n    font-size: 12px;\n  }\n\n  .input {\n    padding: 10px 12px;\n    margin-bottom: 10px;\n  }\n\n  .login-button {\n    padding: 11px 16px;\n  }\n}\n\n@media (max-width: 768px) and (max-height: 700px) {\n  .login-top {\n    padding-top: 8px;\n  }\n\n  .login-top-logo,\n  .login-top > img {\n    width: 160px;\n    margin-bottom: 4px;\n  }\n\n  .login-top > h1 {\n    font-size: 17px;\n    line-height: 22px;\n  }\n\n  .login-subtitle {\n    font-size: 11px;\n  }\n\n  .login-form {\n    padding: 4px 0;\n  }\n\n  .input {\n    padding: 9px 10px;\n    margin-bottom: 8px;\n  }\n\n  .forgot-password {\n    margin-bottom: 8px;\n  }\n\n  .login-button {\n    margin-bottom: 8px;\n    padding: 10px 14px;\n  }\n\n  .signup-link {\n    padding: 6px 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
